<ng-container *transloco="let t; read: 'audio-files-table-editor'">
  <app-data-table
    [actionsTemplate]="actions"
    [cols]="cols"
    [selectedCols]="cols"
    [tableRows]="tableRows$"
    [translationScope]="'audio-files-table-editor'"
  >
    <ng-container appDataTableColumnDef="edit">
      <th *appDataTableHeader>{{ t('colEdit') }}</th>
      <td *appDataTableCell="let rowData">
        <button
          class="p-button-rounded p-button-primary p-button-text"
          pButton
          type="button"
          [attr.aria-label]="t('colEdit')"
          (click)="openEditAudioDialog(rowData)"
        >
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>
    <ng-template #actions>
      <ng-container *ngIf="canCreateAudioFile$ | async">
        <p-button
          icon="pi pi-plus"
          styleClass="p-button-outlined"
          [label]="t('createAudioButtonLabel')"
          (onClick)="openNewAudioDialog()"
        ></p-button>
      </ng-container>
    </ng-template>
  </app-data-table>
</ng-container>
